import { type VendorInviteApiModel } from '../api-models/VendorInviteApiModel'
import { type VendorInvite } from '../types/VendorInvite'

export const mapVendorInviteApiModel = (
  data: VendorInviteApiModel
): VendorInvite => ({
  id: data.id,
  vendorId: data.vendor_id,
  contactEmail: data.contact_email,
  status: data.status,
  createdAt: data.created_at,
  expiresAt: data.expires_at,
  viewedAt: data.viewed_at ?? null,
  acceptedAt: data.accepted_at ?? null,
  connectedAt: data.connected_at ?? null,
  cancelledAt: data.cancelled_at ?? null,
  disconnectedAt: data.disconnected_at ?? null,
})
